import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi, EntiApi, UsersApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useUsersDataSource() {
    const api = new UsersApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getUsers({ tenantId: currentTenant.Id });
          },
    
          byKey: (key) => {
            return api.getUserById({
                tenantId: currentTenant.Id,
                userId: key
            });
          },

          remove: (key) => {
            return api.deleteUser({
                tenantId: currentTenant.Id,
                userId: key
            });
          }

        });
      }, [currentTenant]);
    
      return dataSource;
}


